import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { useSelector } from 'react-redux';
import { useGetCurrencyStore, useSetCurrencyStore } from '../../context/CurrencyContext';
import { useGlobalLoadingState } from '../../context/GlobalLoadingStateContext';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { hasPurchaseMotionsSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { validateCurrencyCode } from '../../utils/currencyUtils';
import { useQueryParamsEffect } from '../../utils/urls/appQueryParamUtilsLegacy';
import { trackCurrencyPickerInteraction } from '../../v2/utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const CurrencyPicker = () => {
  const isAuthApp = useSelector(isAppAuthSelector);
  const setCurrencyStore = useSetCurrencyStore();
  const {
    availableCurrencyCodes,
    lockedCurrencyCode,
    displayedCurrencyCode
  } = useGetCurrencyStore(store => store);

  // Only update URL when we have valid currency data
  const isCurrencyDataLoading = useGlobalLoadingState('Currencies');
  useQueryParamsEffect({
    currencyCode: !isCurrencyDataLoading ? displayedCurrencyCode : undefined
  });
  const handleChange = ({
    target: {
      value: selectedCurrencyCode
    }
  }) => {
    const validatedCurrencyCode = validateCurrencyCode({
      availableCurrencyCodes,
      lockedCurrencyCode,
      displayedCurrencyCode,
      currencyCode: selectedCurrencyCode
    });
    const showCurrencyCodeUnit = validatedCurrencyCode === 'USD';
    setCurrencyStore({
      displayedCurrencyCode: validatedCurrencyCode,
      showCurrencyCodeUnit
    });
    trackCurrencyPickerInteraction({
      action: 'select currency',
      currency: validatedCurrencyCode
    });
  };
  const currencyOptions = availableCurrencyCodes.map(availableCurrency => ({
    text: `${availableCurrency} (${I18n.currencySymbols[availableCurrency].symbol})`,
    value: availableCurrency
  }));
  const currencyCode = useDisplayedCurrencyCode();
  const shouldShowSelector = availableCurrencyCodes && availableCurrencyCodes.length > 1;
  const currencyHasLoaded = useSelector(hasPurchaseMotionsSucceededSelector);

  // If the preferred currency has not loaded yet, we don't want to show the selector with the default currency yet
  if (!shouldShowSelector || isAuthApp && !currencyHasLoaded) {
    return /*#__PURE__*/_jsx("span", {
      style: {
        minHeight: '40px'
      }
    });
  }
  return /*#__PURE__*/_jsx(Select, {
    buttonUse: "transparent",
    menuWidth: 200,
    menuHeight: 320,
    options: currencyOptions,
    onChange: handleChange,
    defaultValue: currencyCode,
    value: currencyCode,
    "data-selenium-id": "currency-picker"
  });
};
export default CurrencyPicker;